"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.postTableRoute = void 0;
exports.postTableRoute = '/table';
//# sourceMappingURL=post.route.js.map